import { useMemo } from "react";

export default function HeroVisual() {
  const dots = useMemo(() => {
    const arr = [];
    for (let ring = 0; ring < 4; ring++) {
      const r = 130 + ring * 50;
      const count = 20 + ring * 8;
      for (let i = 0; i < count; i++) {
        const angle = (i / count) * Math.PI * 2 + ring * 0.3;
        arr.push({
          x: 250 + Math.cos(angle) * r,
          y: 250 + Math.sin(angle) * r,
          r: 0.8 + Math.random() * 1.6,
          o: 0.2 + Math.random() * 0.7,
          delay: Math.random() * 4,
        });
      }
    }
    return arr;
  }, []);

  return (
    <div className="hv-mandala" aria-hidden="true">
      <svg viewBox="0 0 500 500" width="100%" height="100%" style={{ position: "absolute", inset: 0 }}>
        <defs>
          <radialGradient id="silhouette" cx="50%" cy="55%" r="50%">
            <stop offset="0%" stopColor="#5B4B8A" stopOpacity="0.5" />
            <stop offset="60%" stopColor="#0F172A" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#0F172A" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="aura" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D9902F" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#D9902F" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="250" cy="250" r="240" fill="url(#aura)" />
        {[0, 1, 2].map((i) => (
          <circle key={i} cx="250" cy="250" r={90} fill="none" stroke="#E5C16A" strokeWidth="0.8" opacity="0.3"
            style={{ animation: `pulse-ring ${5 + i}s ${i * 1.6}s ease-out infinite`, transformOrigin: "250px 250px" }} />
        ))}
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i / 12) * Math.PI * 2;
          return (
            <ellipse key={i}
              cx={250 + Math.cos(a) * 65} cy={250 + Math.sin(a) * 65}
              rx="60" ry="22" fill="none" stroke="#E5C16A" strokeWidth="0.4" opacity="0.25"
              transform={`rotate(${(i / 12) * 360} ${250 + Math.cos(a) * 65} ${250 + Math.sin(a) * 65})`} />
          );
        })}
        <g opacity="0.95">
          <circle cx="250" cy="155" r="58" fill="url(#silhouette)" opacity="0.5" />
          <circle cx="250" cy="170" r="28" fill="#0a0f1f" />
          <path d="M 200 270 Q 250 200 300 270 Q 320 320 320 360 Q 250 380 180 360 Q 180 320 200 270 Z" fill="#0a0f1f" />
          <path d="M 200 270 Q 250 200 300 270 Q 320 320 320 360 Q 250 380 180 360 Q 180 320 200 270 Z" fill="none" stroke="#E5C16A" strokeWidth="0.6" opacity="0.4" />
          <circle cx="250" cy="170" r="28" fill="none" stroke="#E5C16A" strokeWidth="0.6" opacity="0.4" />
          <circle cx="250" cy="290" r="3" fill="#E5C16A" opacity="0.9" />
          <circle cx="250" cy="290" r="8" fill="none" stroke="#E5C16A" strokeWidth="0.5" opacity="0.5" />
        </g>
        {dots.map((d, i) => (
          <circle key={i} cx={d.x} cy={d.y} r={d.r} fill="#E5C16A" opacity={d.o}>
            <animate attributeName="opacity" values={`${d.o};${d.o * 0.3};${d.o}`}
              dur={`${3 + (i % 5)}s`} begin={`${d.delay}s`} repeatCount="indefinite" />
          </circle>
        ))}
      </svg>
      <div className="hv-card c1">
        <div className="num">TECHNIQUE 01 · VERSE 24</div>
        <div className="ttl">The two origins of breath</div>
        <div className="sub">7 min · Breath doorway</div>
      </div>
      <div className="hv-card c2">
        <div className="num">DAY 02 · SOUND</div>
        <div className="ttl">AUM fading into void</div>
        <div className="sub">8 min · Beginner path</div>
      </div>
      <div className="hv-card c3">
        <div className="num">DAILY · VERSE 117</div>
        <div className="ttl">Heightened sense awareness</div>
        <div className="sub">5 min · Ordinary moment</div>
      </div>
    </div>
  );
}
